<template>
  <v-flex>
    <v-card>
      <v-card-text>

        <v-expansion-panels v-model="panel">
          <v-expansion-panel>
            <v-expansion-panel-header>
              <span style="color: #007ca5;font-size: 18px;font-weight: 900;">
                Representante Legal
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content> 
              <span style="color: #737a82;font-size: 20px;">
                Corretor, com base no CPF informado, localizamos os dados abaixo. Confira as informações, fazendo atualizações se necessário e prossiga no cadastro da Corretora.
              </span>
              <br />
              <br />

              <div class="flex-col-12">
                <div class="flex-row">
                  
                  <div class="flex-col-4">
                    <v-text-field
                      label="CPF"
                      v-model="corretor.Cpf"
                      v-mask="'###.###.###-##'"
                      :rules="[rules.required]"
                      outlined
                    >
                    </v-text-field>
                  </div>

                  <div class="flex-col-4">
                    <v-text-field
                      label="Nome *"
                      v-model="corretor.Nome"
                      :rules="[rules.required]"
                      outlined
                    >
                    </v-text-field>
                  </div>

                  <div class="flex-col-4">
                    <v-text-field
                      label="Sobrenome *"
                      v-model="corretor.SobreNome"
                      :rules="[rules.required]"
                      outlined
                    >
                    </v-text-field>
                  </div>
              </div> 

              <div class="flex-row">
                  <div class="flex-col-3">
                    <v-text-field
                      label="Data de Nascimento"
                      v-model="corretor.DataNascimento"
                      v-mask="'##/##/####'"
                      :rules="[rules.required]"
                      outlined
                    >
                    </v-text-field>
                  </div>
                
                  <div class="flex-col-6">
                    <v-text-field
                      label="E-mail"
                      v-model="corretor.Email"
                      :rules="[rules.required]"
                      outlined
                    >
                    </v-text-field>
                  </div>

                  <div class="flex-col-3">
                    <v-text-field
                      label="Celular *"
                      v-model="corretor.Celuar"
                      v-mask="'(##) #####-####'"
                      :rules="[rules.required]"
                      outlined
                    >
                    </v-text-field>
                  </div>
                </div>

                <div class="flex-row">
                  <div class="flex-col-3">
                    <v-switch
                      label="Tem Sócio? *"
                      v-model="showSocio"
                    ></v-switch>
                  </div>
                </div>

              </div>
                
            </v-expansion-panel-content>
          </v-expansion-panel>  

          <v-expansion-panel v-if="showSocio">
            <v-expansion-panel-header>
              <span style="color: #007ca5;font-size: 18px;font-weight: 900;">
                Quadro Societário
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content> 
              <span style="color: #737a82;font-size: 20px;">
                Por favor adicione os sócios informando o CPF e complemente os dados inserindo e-mail e celular.
              </span>
              <br />
              <br />
              <br />

              <div class="flex-col-12">
                <div class="flex-row">

                  <div class="flex-col-6">
                    <v-text-field
                      v-model="cpfPesquisa"
                      v-mask="'###.###.###-##'"
                      label="Pesquisa"
                      outlined
                      placeholder="Insira o CPF do sócio aqui"
                      class="input-pesquisa"
                      @keyup.enter="pesquisarDocumento()"
                    ></v-text-field>

                  </div>

                  <div class="flex-col-2">
                    <v-btn color="info" @click="pesquisarDocumento()"><v-icon>mdi-magnify</v-icon></v-btn>
                  </div>

                </div>

                <div class="flex-row">

                  <div class="flex-col-3">
                    <v-text-field
                      id="txtCPF"
                      v-model="cpf"
                      v-mask="'###.###.###-##'"
                      label="CPF Sócio"                    
                      type="text"
                      outlined
                    >
                    </v-text-field>
                  </div>

                  <div class="flex-col-3">
                    <v-text-field
                      v-model="nome"
                      type="text"
                      label="Nome Completo *"
                      outlined
                    >
                    </v-text-field>
                  </div>

                  <div class="flex-col-6">
                    <v-text-field
                      v-model="email"
                      label="E-mail"
                      type="mail"
                      :rules="[rules.required, rules.email]"
                      outlined
                    >
                    </v-text-field>
                  </div>

                </div>

                <div class="flex-row">

                  <div class="flex-col-3">
                    <v-text-field
                      id="txtCelular"
                      v-model="celular"
                      label="Celular *"
                      v-mask="'(##) #####-####'"
                      type="text"
                      outlined
                    >
                    </v-text-field>
                  </div>

                  <div class="flex-col-3">
                    <v-text-field
                      id="txtDataNascimento"
                      v-model="dataNascimento"
                      label="Data de Nascimento"
                      type="text"
                      v-mask="'##/##/####'"
                      :rules="[rules.required]"
                      outlined
                    >
                    </v-text-field>
                  </div>

                  <div class="flex-col-3">
                    <v-btn 
                      color="info" 
                      @click="addSocio()"
                    >
                      <v-icon>mdi-account-plus</v-icon>
                      Adicionar
                    </v-btn>
                  </div>

                </div>

                <div class="flex-row">
                  <div class="flex-col-12">

                    <v-data-table
                      :headers="cabecalho"
                      :items="corretor.Socios"
                      hide-default-footer
                      class="elevation-1"
                    >
                      <template v-slot:no-data>&nbsp;</template>
                      <template v-slot:item.actions="{ item }">
                        <v-icon
                          small
                          @click="excluirSocio(item)"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-data-table>
                  </div>

                </div>
              </div>
                
            </v-expansion-panel-content>
          </v-expansion-panel>

        </v-expansion-panels>         

      </v-card-text>

      <v-card-actions :style="`background-color: rgba(243, 243, 243, 0.25) !important; border-top: 1px black !important;`">
        <v-btn 
          :style="`background-color:transparent !important; color:#7fbdd2 !important; width: 106px !important;`"
          @click="ativarAba(0)"
        >
          ANTERIOR
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn 
          :style="`background-color:#7fbdd2 !important; width: 106px !important; height: 35px !important; border-radius: 4px !important;`" 
          class="white--text" 
          @click="salvarDados()"
        >
          PRÓXIMO
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-flex>
</template>


<script>
import Helpers from "@/utilities/Helpers";
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default {
  mixins: [Helpers],

  name: "CorretorDegustacaoDadosCorretor",

  props: ["ativarAba"],

created() {
    setTimeout(() => {
      this.carregarCorretorDegustacao();
    }, 1000);
  },

  methods: {
    
    getCorretorDegustacao(){
      return JSON.parse(localStorage.getItem('corretorDegustacao'));
    },

    carregarCorretorDegustacao()
    { 
      this.fullLoading = true;     
      this.loading = true;

      let codigoCorretor = this.usuario.codCorretor;

      let url = "CorretorDegustacao/Selecionar?id="+codigoCorretor;
      console.log(url);

      Vue.prototype.$httpPortal.get(url).then(res => {
        let dataRequest = res.data;
        console.log(res.data);

        if(!dataRequest.Sucesso) {
          // this.showToast("error", "Erro", "Erro ao carregar os dados do socio do corretor.");
          this.loading = false;
          this.fullLoading = false;
        }

        let corretorDegustacao = dataRequest.ObjetoRetorno;
        this.loading = false;
        this.fullLoading = false;
        this.corretor = corretorDegustacao;

        this.corretor.DataNascimento = this.FormatarData(this.corretor.DataNascimento);
        this.showSocio = this.corretor.Socios.length > 0;

        for (let index = 0; index < this.corretor.Socios.length; index++) {
          this.corretor.Socios[index].DataNascimento = this.FormatarData(this.corretor.Socios[index].DataNascimento);
        }
          
      })
      .catch(ex => {
          console.log(ex);
          this.showToast("error", "Erro", "Ocorreu um problema ao carregar os dados do socio do corretor.");
          this.loading = false;
          this.fullLoading = false;
      });
    },

    pesquisarDocumento(){

      const documento = this.formatarApenasNumero(this.cpfPesquisa);
      let tipoPessoa = documento.length < 14 ? 'PF' : 'PJ';
      const motorBusca = 2; // 2 - Diretrix || 1 - unitfour

      this.$httpPbs.get("pessoa/BuscaCPFCNPJ/"+documento+"/"+tipoPessoa+"/"+motorBusca)
        .then(response => {
          const dados = response.data.data;
          const pessoa = dados.DadosCadastrais;
          let email = "";
          let telefone = "";
          let dataNascimento = "";
          
          if (dados.Emails.length > 0) {
            email = dados.Emails[0].Email.toLowerCase();
          }

          if (dados.Telefones.length > 0) {
            telefone = dados.Telefones[0].Telefone;
          }

          if (pessoa.DataNascimento.length > 0) {
            dataNascimento = pessoa.DataNascimento.split(" ")[0];
          }

          this.cpf = pessoa.CPF;
          this.nome = pessoa.Nome;
          this.email = email;
          this.celular = telefone;
          this.dataNascimento = dataNascimento;
        })
        .catch(error => {
            //quando ele nao encontra, retorna badRequest
            if(error.response && error.response.status === 400){
              this.showToast("warning", "Atenção!", "Dados não encontrados.");
              this.novoSocio();
            }
            console.log(error.response);

        });          
    },

    novoSocio: function() {
      ///Nao sei o pq, mas a mascara trava os valores do campo
      document.getElementById('txtCPF').value = "";
      document.getElementById('txtCelular').value = "";
      document.getElementById('txtDataNascimento').value = "";

      this.cpf = "";
      this.nome = "" ;
      this.email = null ;
      this.celular = "";
      this.dataNascimento = null;
    },

    validarSocio: function() {

      if (this.cpf === "" || this.nome === "" || this.email === "" || this.celular === "" || this.dataNascimento === "") {            
        this.showToast("warning", "Atenção!", "Todos os campos são obrigatórios!");
        return false;
      }

      if(!this.validarIdade(this.dataNascimento,"Sócio", this.idadeMinima)){
        return false;
      }

      if(!this.validarNumeroCelular(this.celular,"Sócio")){
          return false;
      }
      
      let valido = true;

      if (this.corretor.Socios !== null && this.corretor.Socios.length > 0) {           
        this.corretor.Socios.forEach(socioTemp => {
          if (this.formatarApenasNumero(socioTemp.Cpf) === this.formatarApenasNumero(this.cpf)) {            
            this.showToast("error", "Erro!", "Sócio já adicionado.");
            valido = false;
          }
        });
      }

      return valido;
    },

    addSocio: function() {

      if (this.validarSocio()) {
        
        this.corretor.Socios.push({
          Cpf: this.cpf,
          Nome: this.nome,
          Email: this.email,
          Celular: this.celular,
          DataNascimento: this.dataNascimento
        });

        this.novoSocio();
        this.cpfPesquisa = "";
      }
    },

    excluirSocio: function(item) {
      const index = this.corretor.Socios.indexOf(item);
      this.showDialog("Confirma exclusão do sócio?", this.remover, index);
    },

    remover: function(index) {
      this.corretor.Socios.splice(index, 1);
    },

    salvarDados(){
        if(!this.validarIdade(this.corretor.DataNascimento,"Representante Legal",this.idadeMinima)){
          return false;
        }

        if(!this.validarNumeroCelular(this.corretor.Celuar,"Representante Legal")){
          return false;
        }

        this.corretor.Etapa = 3;//Dados Financeiros 
        this.ativarAba(2, this.corretor)
    },    
  },
  computed: {
  ...mapGetters("usuarioModule", { usuario: "getUserInfo" })
  }, 
    data() {
    return {
      cpfPesquisa: "",
      panel: 0,
      showSocio: false,
      corretor: null,

      idadeMinima: 18,

      cpf: "",
      nome: "",
      email: "",
      celular: "",
      dataNascimento: "",
      
      rules: {
          required: value => {
            if (value === "") return 'Campo Obrigatório';
          },
          email: value => {
            if (value !== "" && value !== null && value !== undefined) {
              const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              return pattern.test(value) || 'E-mail inválido.'
            }
          },
      },

      cabecalho: [
        { text: "CPF", value: "Cpf" },
        { text: "Nome", value: "Nome" },
        { text: "E-mail", value: "Email" },
        { text: "Celular", value: "Celular" },
        { text: "Data Nascimento", value: "DataNascimento" },
        { text: "", value: "actions", sortable: false },
      ],
    }
  },

}
</script>